<script>
export default {}
</script>

<template>
<div>
  <strong>In the Tent</strong>
  <ul>
    <li>The Teams</li>
    <li>Your Loadout</li>
    <li>Spawn Points</li>
    <li>How to Win the Round</li>
  </ul>
  <strong>Basic Skills & Techniques</strong>
  <ul>
    <li>Ready, Aim, Fire</li>
    <li>Slice the Pie</li>
    <li>Cover, Concealment, Moving</li>
    <li>Shoot, Then Scoot</li>
  </ul>
  <strong>Team Techniques</strong>
  <ul>
    <li>Radio & Callouts</li>
    <li>Suppressing Fire, Flanks, Ambushes</li>
    <li>Corpsman</li>
  </ul>
</div>
</template>

<style scoped>

</style>
